import React from "react";

const CommonButton = ({
  type = "button",
  onClick,
  label,
  className = "",
  disabled = false,
  icon,
  iconPosition = "start",
  referance,
  onKeyDown,
  variant, // optional, can be ignored if you use custom classes
  size = "md",
  ...rest
}) => {
  const hasLabel = label !== undefined && label !== null && label !== "";
  // Size options
  const sizeClasses = {
    xs: "px-2 py-0.5 text-xs",
    sm: "px-2.5 py-1 text-sm",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  // Optional variant styles (for convenience)
  const variants = {
    "primary-filled": "bg-[#00838F] hover:bg-[#007580] text-white",
    "danger-outline": "text-red-600 border border-red-400 hover:bg-red-50",
    "success-filled": "bg-green-600 hover:bg-green-700 text-white",
    outlined: "text-gray-700 border border-gray-300 hover:bg-gray-50",
  };

  // Final combined class
  const finalClass = !disabled
    ? `
        ${variants[variant] || ""}
        ${sizeClasses[size]}
        ${className}
        flex items-center justify-center
        rounded transition-all duration-300 hover:shadow-md font-medium
      `
    : `
        ${sizeClasses[size]}
        rounded bg-gray-400 text-white
        flex items-center justify-center cursor-not-allowed
      `;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={finalClass.trim()}
      ref={referance}
      onKeyDown={onKeyDown}
      {...rest}
    >
      {icon && iconPosition === "start" && (
        <span className={hasLabel ? "mr-2" : ""}>{icon}</span>
      )}
      {hasLabel && <span>{label}</span>}
      {icon && iconPosition === "end" && (
        <span className={hasLabel ? "ml-2" : ""}>{icon}</span>
      )}
    </button>
  );
};

export default CommonButton;
